import { useEffect, useState } from "react";
import styles from "../dashboard.module.css";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { DashCardLoaderSmall } from "../../../../components/LoaderC";
import { ArrowDown, ArrowUp } from "react-feather";
import dayjs from "dayjs";

const AppliedProspects = ({ selectedProperty, filterDateRange }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [requestData, setRequestData] = useState(null);
    const [contentLoading, setContentLoading] = useState(true);
    const [dateText, setDateText] = useState('new applications the last 30 days');

    useEffect(() => {
        const fetchData = async (pId) => {
            setContentLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            let params = {};

            if (filterDateRange?.start && filterDateRange?.end) {
                params = { start: filterDateRange?.start, end: filterDateRange?.end };
                setDateText('new applications received on ' + dayjs(filterDateRange?.start).format('MM/DD') + ' - ' + dayjs(filterDateRange?.end).format('MM/DD'));
                if (filterDateRange?.start === filterDateRange?.end) {
                    setDateText('new applications received on ' + dayjs(filterDateRange?.start).format('MM/DD'));
                }
            } else {
                setDateText('new applications the last 30 days');
            }

            if (pId > 0) {
                await axios.get(process.env.REACT_APP_USER_API_URL + "v1/dashboard/get-prospects-status/" + pId, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: params
                }).then((response) => {
                    setContentLoading(false);
                    setRequestData(response.data.data);
                }).catch((error) => {
                    setContentLoading(false);
                    setRequestData(null);
                });
            } else {
                await axios.get(process.env.REACT_APP_USER_API_URL + "v1/dashboard/get-prospects-status", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: params
                }).then((response) => {
                    setContentLoading(false);
                    setRequestData(response.data.data);
                }).catch((error) => {
                    setContentLoading(false);
                    setRequestData(null);
                });
            }
        }

        if (selectedProperty > 0) {
            fetchData(selectedProperty);
        } else {
            fetchData(0);
        }
    }, [selectedProperty, getAccessTokenSilently, filterDateRange]);

    return (<div className={`${styles.ScoreCards}`}>
        {contentLoading && (<div className={`${styles.LoaderDash3}`}>
            <div><DashCardLoaderSmall /></div>
        </div>)}

        {!contentLoading && (<div className={`${styles.ScoreCardsFull}`}>
            <div className={`${styles.ScoreCardsUnder}`}>
                <div className={`${styles.ScoreCardCon}`}>
                    <p className={`${styles.ScoeCardTitle}`}># of New Applications</p>
                    <div className={`${styles.ScorePrograssBar}`}>
                        <div className={`${styles.PrograssScore}`} style={{ width: requestData ? requestData?.new_percentage + '%' : '0%' }}></div>
                    </div>
                    <div className={`${styles.ScoreMiddleArea}`}>
                        <p className={`${styles.ScoeCardCon}`}>{requestData ? requestData?.new_percentage : 0}%</p>
                        <div className={(requestData && requestData?.is_increase === 1) ? `${styles.ScoreUpDOwnArrow} ${styles.Green}` : `${styles.ScoreUpDOwnArrow} ${styles.Red}`}>{(requestData && requestData?.is_increase === 1) ? <ArrowUp /> : <ArrowDown />}</div>
                        <p className={`${styles.ScoeCardConTwo}`}>{requestData ? requestData?.new_data : 0} / {requestData ? requestData?.total : 0}</p>
                    </div>
                    <p className={`${styles.ScoreCardLMsg}`}><span>{requestData ? requestData?.new_data : 0}</span> {dateText}</p>
                </div>
            </div>
        </div>)}
    </div>);
}

export default AppliedProspects;